module.exports = __webpack_public_path__ + "static/media/emporter_transparent.5b2cf966.png";